<template>
  <v-data-table
    calculate-widths
    class="supplier-contact-people-table"
    disable-pagination
    fixed-header
    :headers="headers"
    hide-default-footer
    item-key="index"
    :items="items"
    :no-data-text="$t('Tenders.NoData')">
    <template #[`item`]="{ item, index, headers: headersItem }">
      <tr
        :key="'1tr' + index"
        class="first-tr"
        :data-qa="'first-tr' + index">
        <td
          v-for="header in headersItem"
          :key="header.value + index"
          class="text-start main__light_green "
          :class="[ header.value + '-td' ]"
          :data-qa="'first-td' + header.value"
          :rowspan=" header.value == 'fullName' ? 2 : 1"
          :style="'width:' + header.width">
          <template v-if="header.value == 'fullName'">
            <div class="flex flex-wrap flex-direction-column">
              <div class="h7-text text-start black--text">
                {{ item.fullName || '–' }}
              </div>
              <div class="h8-text text-start secondary__green_not_active--text ">
                {{ item.email || '–' }}
              </div>
              <div class="h8-text text-start secondary__green_not_active--text ">
                {{ item.phoneNumber || '–' }}
              </div>
            </div>
          </template>
          <template v-if="header.value == 'columns' ">
            <div class="flex flex-wrap flex-direction-column h11-links secondary__green_not_active--text text-start">
              {{ $t('Suppliers.All') }}
            </div>
          </template>
          <template v-if="header.value == 'bids' ">
            {{ formSum( item.bids.count ) }}
            <span v-if="item.bids.count"> {{ $t('Suppliers.pcs') }}</span>
          </template>
          <template v-if="header.value == 'pricesSum' ">
            {{ formSum( item.bids.pricesSum ) }}
            <span v-if="item.bids.pricesSum">{{ $t('Tenders.hrn') }}</span>
          </template>
          <template v-if="header.value == 'wins' ">
            {{ formSum( item.wins.count ) }}
            <span v-if="item.wins.count"> {{ $t('Suppliers.pcs') }}</span>
          </template>
          <template v-if="header.value == 'wins_pricesSum' ">
            {{ formSum( item.wins.pricesSum ) }}
            <span v-if="item.wins.pricesSum">{{ $t('Tenders.hrn') }}</span>
          </template>
        </td>
      </tr>
      <tr
        :key="'2tr' + index"
        class="second-tr"
        :data-qa="'second-tr' + index">
        <td
          v-for="header in headers.slice(1)"
          :key="header.value + index"
          class="text-start main__light_green "
          :class="[ header.value + '-td' ]"
          :data-qa="'second-td' + header.value"
          :style="'width:' + header.width">
          <template v-if="header.value == 'columns' ">
            <div class=" h11-links secondary__green_not_active--text  text-start ">
              {{ $t('Suppliers.AccordingToMyOrganization') }}
            </div>
          </template>
          <template v-if="header.value == 'bids' ">
            {{ formSum( item.bids.countInOwnTender ) }}
            <span v-if="item.bids.countInOwnTender"> {{ $t('Suppliers.pcs') }}</span>
          </template>
          <template v-if="header.value == 'pricesSum' ">
            {{ formSum( item.bids.pricesSumInOwnTender ) }}
            <span v-if="item.bids.pricesSumInOwnTender">{{ $t('Tenders.hrn') }}</span>
          </template>
          <template v-if="header.value == 'wins' ">
            {{ formSum( item.wins.countInOwnTender ) }}
            <span v-if="item.wins.countInOwnTender"> {{ $t('Suppliers.pcs') }}</span>
          </template>
          <template v-if="header.value == 'wins_pricesSum' ">
            {{ formSum( item.wins.pricesSumInOwnTender ) }}
            <span v-if="item.wins.pricesSumInOwnTender">{{ $t('Tenders.hrn') }}</span>
          </template>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { modalMixin } from 'mixins'

export default {
  name: 'supplierContactPeople',
  mixins: [modalMixin],
  data() {
    return {
      items: []
    }
  },
  async created() {
    this.items = await this.$store.dispatch('getTenderSupplierParticipants', +this.$route.params.id) || []
  },
  computed: {
    headers() {
      return [
        {text: this.$t('Tenders.ContactPerson'), value: 'fullName', width: '22%' },
        {text: '', value: 'columns', width: '23%', sortable: false },
        {text: this.$t('Tenders.Offers'), value: 'bids', sortable: false, width: '10%' },
        {text: this.$t('Suppliers.InAmountOf'), value: 'pricesSum', sortable: false, width: '17%' },
        {text: this.$t('Suppliers.Victories'), value: 'wins', sortable: false, width: '10%' },
        {text: this.$t('Suppliers.InAmountOf'), value: 'wins_pricesSum', sortable: false, width: '18%' },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.supplier-contact-people-table.v-data-table {
  tbody {
    tr {
      td {
        min-height: unset !important;
        height: unset !important;
      }
      &.first-tr {
        td:not(:first-child) {
          padding: 10px 10px 5px 10px !important ;
        }
        td:not(:first-child):not(.sForm-cell-error) {
          border-bottom: none !important;
        }
      }
    }
  }
}

</style>
<style lang="scss">
#components-layout-supplier-item {
  .supplier-contact-people-table.v-data-table {
    tbody {
      tr {
        &.second-tr {
          td {
            padding: 5px 10px 10px 10px !important ;
          }
        }
      }
    }
  }


}
</style>
